import { render } from "./ParticleVue32.vue?vue&type=template&id=0ad649fc&scoped=true"
import script from "./ParticleVue32.vue?vue&type=script&lang=js"
export * from "./ParticleVue32.vue?vue&type=script&lang=js"

import "./ParticleVue32.vue?vue&type=style&index=0&id=0ad649fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad649fc"]])

export default __exports__